import * as React from "react";
import {Dokument} from "../types/generated";
import Vadis from "services/vadisKontrollrapportService";
import "./Lenkeliste.scss"

type Props = {
    dokumenter: Dokument[],
    overskrift: string
}

function Dokumentliste(props: Props) {
    const lenke = (lenke: Dokument) => {
        return (
            <li key={lenke.id} data-hj-suppress>
                <a href={`${Vadis.getApiUrl()}/kontrollrapport/dokument/${lenke.id}`}>
                    {lenke.tittel}
                </a>
            </li>
        )
    };

    return (
        <div className="dokumentliste util-avstand-topp-bunn-middels">
            <h3 className="overskrift"><span>{props.overskrift}</span></h3>
            <ul className="liste-ustilet">
                {props.dokumenter.map(lenke)}
            </ul>
        </div>
    )
}

export default Dokumentliste;
